// ArChat — texto del aviso visual en lista de contactos (solo fuente; no sonido ni CSS).
// Author: SIVOL® — 2026-04-14

/**
 * Línea de preview para el highlight de mensaje entrante: debe reflejar el payload WS
 * recién recibido, no `ultimo_mensaje_*` del contacto (puede estar desactualizado hasta el GET).
 *
 * Reglas de producto (alineadas con `contactListPreview.js`):
 * - Texto válido → truncado (maxLen).
 * - Imagen → "Foto".
 * - Archivo no imagen, audio y video → "Archivo" (audio/video unificados con archivo en el mismo placeholder).
 *
 * @param {Record<string, unknown>|null|undefined} raw - Payload normalizado / detalle WS (puede incluir `raw` anidado).
 * @param {{ maxLen?: number }} [opts]
 * @returns {string}
 */
export function resolveIncomingVisualPreviewSubtitle(raw, opts = {}) {
  if (!raw || typeof raw !== 'object') return '\u2026';
  const maxLen = typeof opts.maxLen === 'number' && opts.maxLen > 0 ? opts.maxLen : 80;
  const nested = raw.raw && typeof raw.raw === 'object' ? raw.raw : {};

  const tipoRaw = String(
    raw.tipo ?? raw.tipo_mensaje ?? raw.message_type ?? raw.type ?? nested.tipo ?? ''
  )
    .toLowerCase()
    .trim();

  const mimeRaw = String(
    raw.archivo_mime_type ??
      raw.mime_type ??
      raw.mimetype ??
      nested.archivo_mime_type ??
      ''
  ).toLowerCase();

  const hasImageMime = mimeRaw.startsWith('image/');

  const hasAttachment = Boolean(
    raw.archivo_data ??
      raw.archivo_url ??
      raw.archivo_nombre_original ??
      raw.archivo_nombre ??
      (Number(raw.archivo_tamano) > 0 ? raw.archivo_tamano : null) ??
      nested.archivo_data ??
      nested.archivo_url ??
      nested.archivo_nombre
  );

  const isImageTipo =
    tipoRaw === 'imagen' ||
    tipoRaw === 'image' ||
    tipoRaw === 'photo' ||
    tipoRaw === 'picture' ||
    tipoRaw === 'foto';

  if (isImageTipo || (hasAttachment && hasImageMime)) return 'Foto';

  const isNonImageAttachmentKind =
    tipoRaw === 'archivo' ||
    tipoRaw === 'audio' ||
    tipoRaw === 'video' ||
    tipoRaw === 'sistema' ||
    tipoRaw === 'file';

  if (isNonImageAttachmentKind || (hasAttachment && !hasImageMime)) return 'Archivo';

  const text = String(
    raw.display_text ??
      raw.text ??
      raw.message ??
      raw.mensaje ??
      raw.contenido ??
      nested.display_text ??
      nested.text ??
      nested.mensaje ??
      ''
  ).trim();

  if (text) {
    return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text;
  }

  if (hasAttachment) return 'Archivo';

  if (tipoRaw === 'texto' || tipoRaw === 'text') return '\u2026';

  return '\u2026';
}
